module.exports = __webpack_public_path__ + "static/media/arch5.c61ff55e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arch5.jpg
// module id = 5791
// module chunks = 0